import { createIcon } from '../utils';

export const CardAcceptedIcon = createIcon(
  ({ ref, className, width, height, ...rest }) => (
    <svg
      ref={ref}
      className={className}
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g clipPath="url(#clip0_2354_24388)">
        <path
          d="M13.3334 15L15.0001 16.6666L18.3334 13.3333M18.3334 8.33329H1.66675M18.3334 9.99996V6.83329C18.3334 5.89987 18.3334 5.43316 18.1518 5.07664C17.992 4.76304 17.737 4.50807 17.4234 4.34828C17.0669 4.16663 16.6002 4.16663 15.6667 4.16663H4.33342C3.39999 4.16663 2.93328 4.16663 2.57676 4.34828C2.26316 4.50807 2.00819 4.76304 1.8484 5.07664C1.66675 5.43316 1.66675 5.89987 1.66675 6.83329V13.1666C1.66675 14.1 1.66675 14.5668 1.8484 14.9233C2.00819 15.2369 2.26316 15.4918 2.57676 15.6516C2.93328 15.8333 3.39999 15.8333 4.33341 15.8333H10.0001"
          stroke="currentColor"
          strokeWidth={1.4}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_2354_24388">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  { displayName: 'CardAcceptedIcon' },
);
